import { render, staticRenderFns } from "./CategoryTreeContent.vue?vue&type=template&id=3aabf2a0&scoped=true"
import script from "./CategoryTreeContent.vue?vue&type=script&lang=js"
export * from "./CategoryTreeContent.vue?vue&type=script&lang=js"
import style0 from "./CategoryTreeContent.vue?vue&type=style&index=0&id=3aabf2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aabf2a0",
  null
  
)

export default component.exports